export default () => ({
    status: false,
    user: null,
    idToken : null
})